import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Decline ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gv_markdown = _resolveComponent("gv-markdown")!
  const _component_gv_button = _resolveComponent("gv-button")!
  const _component_gv_type = _resolveComponent("gv-type")!
  const _component_mobile = _resolveComponent("mobile")!

  return (_openBlock(), _createBlock(_component_mobile, null, {
    default: _withCtx(() => [
      _createVNode(_component_gv_markdown, { markdown: _ctx.consentContent }, null, 8, ["markdown"])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_gv_button, {
          size: "lg",
          text: "I Agree",
          to: "/service/safewa/link"
        }),
        _createVNode(_component_gv_button, { variant: "text" }, {
          default: _withCtx(() => [
            _createVNode(_component_gv_type, {
              scheme: "custom",
              class: "text-outbackRed text-center w-full",
              onClick: _ctx.onDecline
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}